import React, { useContext, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faShippingFast } from '@fortawesome/free-solid-svg-icons';
import { DataContext } from '../contexts/DataContext';

const ShipmentStatusCard = () => {
  const { shipments } = useContext(DataContext); // Assuming shipments data is available in DataContext
  const [completedCount, setCompletedCount] = useState(0);
  const [inTransitCount, setInTransitCount] = useState(0);

  useEffect(() => {
    // Compute counts based on shipments data from DataContext
    const completedShipments = shipments.filter(shipment => shipment.jobStatus === "CMP").length;
    const inTransitShipments = shipments.filter(shipment => shipment.jobStatus !== "CMP").length;
    
    setCompletedCount(completedShipments);
    setInTransitCount(inTransitShipments);
  }, [shipments]); // Recompute when shipments data changes

  return (
    <div className="bg-white shadow rounded-lg p-6 w-full max-w-lg h-custom-card-small">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faShippingFast} className="text-blue-600 mr-3" />
          Shipment Status
        </h2>
        <a href="/shipment-status" className="text-md text-blue-600 hover:text-blue-800 transition duration-300">
          View all
        </a>
      </div>
      <div className="grid grid-cols-2 divide-x divide-gray-200 text-center">
        <div className="px-4 py-2">
          <FontAwesomeIcon icon={faCheckCircle} className="text-green-600 text-3xl mb-2" />
          <p className="text-md text-gray-600">Completed</p>
          <p className="text-2xl font-semibold text-gray-800">{completedCount}</p>
        </div>
        <div className="px-4 py-2">
          <FontAwesomeIcon icon={faShippingFast} className="text-orange-600 text-3xl mb-2" />
          <p className="text-md text-gray-600">In-Transit</p>
          <p className="text-2xl font-semibold text-gray-800">{inTransitCount}</p>
        </div>
      </div>
    </div>
  );
};

export default ShipmentStatusCard;
